
import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import selectedCoinObj from '../../../selectors/selectedCoinObj';
import Chart from '../../components/chart'
import SocialMediaBox from '../../components/socialMediaBox'
import { setTrackedDays } from '../../../actions/ui/index.js'
import cn from 'classnames'
import './styles.css'

class MobChartView extends PureComponent {


  render = () => {
    const { setTrackedDays, trackedDays } = this.props
    return(
      <fb className="mob-chart-view-main">
        <fb className="head">
          <fb className="back-btn">
            <fb className="icon icon-navigate_before"></fb>
            <fb className="text" onClick={()=>{this.props.history.push('/mob/coins')}}>BACK</fb>
          </fb>
        </fb>
        <fb className="content">
          <fb className="mainRow">
            <fb className="coinName">{ this.props.coin.name }</fb>
            <fb className="mcap">
              <fb className="label">Market Cap:</fb>
              <fb className="number">{ Math.round(this.props.coin.mcap / 1000000) + ' m' }</fb>
            </fb>
          </fb>
          <fb className="configsRow">
            <fb className="trackedDays">
              <fb className={cn({btn: 1, active: trackedDays === 30  })} onClick={() => setTrackedDays(30)}>30 Days</fb>
              <fb className={cn({btn: 1, active: trackedDays === 14  })} onClick={() => setTrackedDays(14)}>14 Days</fb>
              <fb className={cn({btn: 1, active: trackedDays === 7  })} onClick={() => setTrackedDays(7)}>7 Days</fb>
            </fb>
          </fb>
          <fb className="chart-wrapper">
            <Chart mobileVersion/>
          </fb>
          <fb className="socialMediaBoxWrapper">
            <SocialMediaBox mobileVersion/>
          </fb>
        </fb>
      </fb>
    )
  }
}

const mapDispatchToProps = {
  setTrackedDays,
}

const mapStateToProps = (state: Store) => ({
  coin: selectedCoinObj(state),
  trackedDays: state.ui.trackedDays,
})

export default connect(mapStateToProps, mapDispatchToProps)(MobChartView)



// WEBPACK FOOTER //
// ./src/containers/mob/mobChartView/index.js